import { getconfiglist } from "../service/home";
import { createModel } from "@rematch/core"

const config = {
  name: "config",
  state: {}, // initial state
  reducers: {
    setConfig(state, payload) {
      return {
        ...state,
        ...payload,
      }
    }
  },
  effects: (dispatch) => ({
    // handle state changes with impure functions.
    // use async/await for async actions
    async setConfigAsync() {
      const config = await getconfiglist();
      console.log("config is", config);
      this.setConfig(config);
    },
  }),
};

export default config
